import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext.jsx';
import { tieneModulo } from './config/modulos.js';
import Layout from './components/Layout.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import POS from './pages/POS.jsx';
import Ventas from './pages/Ventas.jsx';
import VentasFiscales from './pages/VentasFiscales.jsx';
import CuentasPorCobrar from './pages/CuentasPorCobrar.jsx';
import Inventario from './pages/Inventario.jsx';
import Clientes from './pages/Clientes.jsx';
import Proveedores from './pages/Proveedores.jsx';
import Compras from './pages/Compras.jsx';
import Recibidos from './pages/Recibidos.jsx';
import Gastos from './pages/Gastos.jsx';
import Caja from './pages/Caja.jsx';
import Empleados from './pages/Empleados.jsx';
import Reportes from './pages/Reportes.jsx';
import Configuracion from './pages/Configuracion.jsx';
import Comprobante from './pages/Comprobante.jsx';
import ReparacionPublica from './pages/ReparacionPublica.jsx';
import Reparaciones from './pages/Reparaciones.jsx';

function Privada({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/comprobante/:token" element={<Comprobante />} />
      {/* Seguimiento publico de una reparacion. Solo existe si el negocio
          tiene el modulo: sin el, la ruta no se registra. */}
      {tieneModulo('reparaciones') && (
        <Route path="/reparacion/:token" element={<ReparacionPublica />} />
      )}
      <Route
        path="/*"
        element={
          <Privada>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/pos" element={<POS />} />
                <Route path="/ventas" element={<Ventas />} />
                <Route path="/ventas-fiscales" element={<VentasFiscales />} />
                <Route path="/cuentas-por-cobrar" element={<CuentasPorCobrar />} />
                <Route path="/inventario" element={<Inventario />} />
                <Route path="/clientes" element={<Clientes />} />
                <Route path="/proveedores" element={<Proveedores />} />
                <Route path="/compras" element={<Compras />} />
                <Route path="/recibidos" element={<Recibidos />} />
                <Route path="/gastos" element={<Gastos />} />
                <Route path="/caja" element={<Caja />} />
                {tieneModulo('reparaciones') && <Route path="/reparaciones" element={<Reparaciones />} />}
                <Route path="/empleados" element={<Empleados />} />
                <Route path="/reportes" element={<Reportes />} />
                <Route path="/configuracion" element={<Configuracion />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Privada>
        }
      />
    </Routes>
  );
}
